import React, { useState, useEffect } from 'react';
import api from '../utils/api';

const SuccessPage = () => {
    const [loading, setLoading] = useState(true);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');
    const [employeeData, setEmployeeData] = useState(null);

    useEffect(() => {
        const processSuccess = async () => {
            try {
                // Get session ID from URL parameters
                const urlParams = new URLSearchParams(window.location.search);
                const sessionId = urlParams.get('session_id');
                const type = urlParams.get('type');

                if (!sessionId) {
                    setError('No session ID found');
                    setLoading(false);
                    return;
                }

                if (type === 'add_employee') {
                    // Process add employee success
                    console.log('Processing add employee success for session:', sessionId);
                    
                    const response = await api.post('/api/companies/verify-add-employee', {
                        sessionId: sessionId
                    });

                    if (response.data.success) {
                        setEmployeeData(response.data.employee);
                        setSuccess(true);
                    } else {
                        setError('Failed to verify payment');
                    }
                } else {
                    setError('Unknown success type');
                }
            } catch (err) {
                console.error('Success processing error:', err);
                setError(err.response?.data?.error || 'Failed to process success');
            } finally {
                setLoading(false);
            }
        };

        processSuccess();
    }, []);

    const handleBackToEmployees = () => {
        // Force a page refresh to ensure the employee list is updated
        window.location.href = '/employees?refresh=true';
    };

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                backgroundColor: '#1E1E1E',
                color: 'white'
            }}>
                <div style={{ textAlign: 'center' }}>
                    <div style={{
                        width: '50px',
                        height: '50px',
                        border: '3px solid #1961FD',
                        borderTop: '3px solid transparent',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                        margin: '0 auto 20px'
                    }}></div>
                    <p>Processing your payment...</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                backgroundColor: '#1E1E1E',
                color: 'white'
            }}>
                <div style={{
                    textAlign: 'center',
                    maxWidth: '400px',
                    padding: '40px'
                }}>
                    <div style={{
                        fontSize: '48px',
                        marginBottom: '20px'
                    }}>❌</div>
                    <h2 style={{ marginBottom: '20px' }}>Payment Error</h2>
                    <p style={{ 
                        marginBottom: '30px',
                        color: '#9CA3AF'
                    }}>{error}</p>
                    <button
                        onClick={handleBackToEmployees}
                        style={{
                            padding: '12px 24px',
                            borderRadius: '6px',
                            border: 'none',
                            backgroundColor: '#1961FD',
                            color: 'white',
                            fontSize: '14px',
                            fontWeight: '500',
                            cursor: 'pointer'
                        }}
                    >
                        Back to Employees
                    </button>
                </div>
            </div>
        );
    }

    if (success && employeeData) {
        return (
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100vh',
                backgroundColor: '#1E1E1E',
                color: 'white'
            }}>
                <div style={{
                    textAlign: 'center',
                    maxWidth: '500px',
                    padding: '40px'
                }}>
                    <div style={{
                        fontSize: '48px',
                        marginBottom: '20px'
                    }}>✅</div>
                    <h2 style={{ marginBottom: '20px' }}>Employee Added Successfully!</h2>
                    <div style={{
                        backgroundColor: '#2D2D2D',
                        borderRadius: '12px',
                        padding: '24px',
                        marginBottom: '30px',
                        textAlign: 'left'
                    }}>
                        <h3 style={{ 
                            marginBottom: '16px',
                            color: '#1961FD'
                        }}>New Employee Details:</h3>
                        <p><strong>Name:</strong> {employeeData.firstName} {employeeData.lastName}</p>
                        <p><strong>Email:</strong> {employeeData.email}</p>
                        <div style={{
                            marginTop: '16px',
                            padding: '12px',
                            backgroundColor: 'rgba(25, 97, 253, 0.1)',
                            borderRadius: '6px',
                            border: '1px solid rgba(25, 97, 253, 0.3)'
                        }}>
                            <p style={{ 
                                margin: '0 0 8px 0',
                                fontSize: '14px',
                                color: '#9CA3AF'
                            }}>
                                🔑 <strong>Login Instructions:</strong>
                            </p>
                            <p style={{ 
                                margin: '0 0 4px 0',
                                fontSize: '14px',
                                color: '#9CA3AF'
                            }}>
                                Email: {employeeData.email}
                            </p>
                            <p style={{ 
                                margin: '0 0 8px 0',
                                fontSize: '14px',
                                color: '#9CA3AF'
                            }}>
                                Temporary Password: <code style={{ 
                                    backgroundColor: 'rgba(255, 255, 255, 0.1)', 
                                    padding: '2px 4px', 
                                    borderRadius: '3px',
                                    fontFamily: 'monospace'
                                }}>defaultpass</code>
                            </p>
                            <p style={{ 
                                margin: 0,
                                fontSize: '12px',
                                color: '#6B7280',
                                fontStyle: 'italic'
                            }}>
                                The employee should change this password after first login.
                            </p>
                        </div>
                    </div>
                    <button
                        onClick={handleBackToEmployees}
                        style={{
                            padding: '12px 24px',
                            borderRadius: '6px',
                            border: 'none',
                            backgroundColor: '#1961FD',
                            color: 'white',
                            fontSize: '14px',
                            fontWeight: '500',
                            cursor: 'pointer'
                        }}
                    >
                        Back to Employees
                    </button>
                </div>
            </div>
        );
    }

    return null;
};

// Add CSS animation for loading spinner
const style = document.createElement('style');
style.textContent = `
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
`;
document.head.appendChild(style);

export default SuccessPage; 